import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { UseCase } from "../../base/use-case";
import { BaseGridResponse } from "../../../data/shared/base-grid.response";
import { BaseRequest } from "planning-portal-library/src/lib/data/shared/base.request";
import { MasterPlansRepository } from "../../repositories";
import { GetMasterPlansRequest, MasterPlan } from "../../domain";

@Injectable({ providedIn: 'root' })
export class GetMasterPlansUsecase implements UseCase<BaseRequest<GetMasterPlansRequest>, BaseGridResponse<MasterPlan>> {

  constructor(private readonly masterPlanRepository: MasterPlansRepository) {
  }

  execute(params: BaseRequest<GetMasterPlansRequest>): Observable<BaseGridResponse<MasterPlan>> {
    return this.masterPlanRepository.getMasterPlans(params);
  }

}
